import { UnContext } from "../context/UnContext";
import { useContext } from "react";

export const useUnContext = () => {
    const context = useContext(UnContext);

    if (!context) {
        return Error('useUnContext must be used inside an UnContextProvider');
    };

    return context;
};